import { normalizePhone } from '../../utils/phoneUtils';

/**
 * Encontra um cliente pelo telefone (comparação normalizada).
 * Suporta até 3 campos: phone, phone2, phone3.
 * Agora também considera o código do país selecionado.
 *
 * @param {Array} clientes
 * @param {string} telefone
 * @param {string} countryCode - Código do país do telefone pesquisado. Padrão: '351' (Portugal)
 * @returns {object|null}
 */
export function encontrarClientePorTelefone(clientes, telefone, countryCode = '351') {
  const digits = normalizePhone(telefone, countryCode);
  if (!digits || digits.length < 6) return null;

  // Códigos de país comuns para tentar (retrocompatibilidade)
  const codesToTry = [countryCode, '351', '49', '33', '31', '44', '34', '39', '41', '32', '45', '46', '47', '358'];

  return (clientes || []).find(c => {
    // Tentar normalizar com vários códigos de país (para retrocompatibilidade)
    for (const code of codesToTry) {
      const p1 = normalizePhone(c?.phone, code);
      const p2 = normalizePhone(c?.phone2, code);
      const p3 = normalizePhone(c?.phone3, code);
      if (digits === p1 || digits === p2 || digits === p3) {
        return true;
      }
    }
    return false;
  }) || null;
}




